const ordinalWords: Record<number, string> = {
  1: 'First',
  2: 'Second',
  3: 'Third',
  4: 'Fourth',
  5: 'Fifth',
  6: 'Sixth',
  7: 'Seventh',
  8: 'Eighth',
  9: 'Ninth',
  10: 'Tenth',
};

export const numberToOrdinalWord = (n: number) => {
  const ordinalWord = ordinalWords[n];
  if (ordinalWord) return ordinalWord;

  const ordinalSuffixes = ['th', 'st', 'nd', 'rd'];
  const lastTwoDigits = n % 100;

  return (
    String(n) +
    (ordinalSuffixes[(lastTwoDigits - 20) % 10] ||
      ordinalSuffixes[lastTwoDigits] ||
      ordinalSuffixes[0])
  );
};
